import React from "react";
import i18next from "../localization/i18n";
import EditNoteIcon from "@mui/icons-material/EditNote";
import SaitRowAction from "./SaitRowAction";
import { saitfecoreNs } from "../utils/Constants";

/*
	Obbligatori:
		id
		onClick
	Facoltativi:
*/

export default function SaitRowActionEdit(props) {
	return SaitRowAction({
		id: props.id,
		icon: <EditNoteIcon color="primary" />,
		tooltip: i18next.t("edit", { ns: saitfecoreNs }),
		onClick: props.onClick,
		conditionalRendering: props.conditionalRendering,
		roleSecurity: props.roleSecurity,
		objmod: props.objmod,
		hidden: props.hidden,
	});
}
